import { useSelector } from 'react-redux';
import { salesChannelSelector } from '../_selectors';

export const useIsTextBuy = (): boolean => {
    const salesChannelData = useSelector(salesChannelSelector).data;
    const isTextBuy = salesChannelData && salesChannelData?.SalesChannel?.isTextBuy;

    return Boolean(isTextBuy);
};
